import { useSetRecoilState } from 'recoil';
import useDomEventListener from './use-dom-event-listener.js';
export const useFetchServiceOnFocus = ({ serviceState, }) => {
    const setStale = useSetRecoilState(serviceState.stale);
    useDomEventListener('focus', () => {
        setStale(`${new Date().valueOf()}`);
    });
};
export default useFetchServiceOnFocus;
//# sourceMappingURL=use-fetch-service-on-focus.js.map